import {useState} from '#app';
import type {ExperienceRequest} from '~/types/infra/ExperienceRequest';

export const useExperienceSectionState = () => useState<ExperienceRequest[]>('experience-section-state', () => []);
